import React, { useEffect, useState } from 'react';
import './Prices.css';
import { getPrices } from '../services/pricesApi';
import {
    formatCena,
    formatDni,
    isHighlight,
    extractSurcharge,
    splitColumns,
} from '../utils/priceFormat';

// Wybiera domyślnie aktywny okres: domyslna === "1", inaczej pierwszy po kolejnosci.
function pickDefaultId(periods) {
    const def = periods.find((p) => String(p.domyslna) === '1');
    return (def ?? periods[0])?.okres_id ?? null;
}

function PricesTable({ period }) {
    const { rows, surcharge } = extractSurcharge(period.cenniki);
    const [left, right] = splitColumns(rows);
    const maxRows = Math.max(left.length, right.length);

    return (
        <div className="prices-table">
            {Array.from({ length: maxRows }, (_, i) => {
                const cells = [left[i], right[i]];
                return (
                    <div className="prices-row" key={i}>
                        {cells.map((cell, col) =>
                            cell ? (
                                <div
                                    className={
                                        isHighlight(cell.dni)
                                            ? 'prices-item prices-highlight'
                                            : 'prices-item'
                                    }
                                    key={col}
                                >
                                    <div>{formatDni(cell.dni)}</div>
                                    <div>{formatCena(cell.cena)}</div>
                                </div>
                            ) : (
                                <div className="prices-item-empty" key={col} />
                            ),
                        )}
                    </div>
                );
            })}
            {surcharge !== null && (
                <div className="prices-row-alt">
                    <div className="prices-item-alt">kolejna doba</div>
                    <div className="prices-item-alt">+{formatCena(surcharge)}</div>
                </div>
            )}
        </div>
    );
}

function Prices() {
    const [periods, setPeriods] = useState([]);
    const [activeId, setActiveId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const applyData = (data) => {
            if (cancelled) return;
            const sorted = [...data].sort(
                (a, b) => (parseInt(a.kolejnosc, 10) || 0) - (parseInt(b.kolejnosc, 10) || 0),
            );
            setPeriods(sorted);
            // Zachowaj wybrany tab jeśli nadal istnieje, inaczej ustaw domyślny.
            setActiveId((prev) =>
                prev && sorted.some((p) => p.okres_id === prev) ? prev : pickDefaultId(sorted),
            );
            setLoading(false);
        };

        // applyData wołane 2x: raz z cache (natychmiast), raz ze świeżym API.
        getPrices(applyData).then(applyData);

        return () => {
            cancelled = true;
        };
    }, []);

    const activePeriod = periods.find((p) => p.okres_id === activeId);

    return (
        <div>
            <div className="wavestop-prices">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                    <path fill="#D8ECFF"
                          d="M0,96L48,80C96,64,192,32,288,21.3C384,11,480,21,576,42.7C672,64,768,96,864,112C960,128,1056,128,1152,112C1248,96,1344,64,1392,48L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
                </svg>
            </div>
            <div className="prices-wrapper" id="prices-section">
                <div className="prices-title"><h3>CENNIK</h3></div>

                {loading ? (
                    <div className="prices-loading">Ładowanie cennika…</div>
                ) : (
                    <>
                        <div className="prices-tabs-wrapper">
                            {periods.map((p) => (
                                <div
                                    key={p.okres_id}
                                    className={p.okres_id === activeId ? 'price-tab price-active' : 'price-tab'}
                                    onClick={() => setActiveId(p.okres_id)}
                                >
                                    {p.nazwa_okresu}
                                </div>
                            ))}
                        </div>

                        {activePeriod?.opis?.trim() && (
                            <div className="prices-period-opis">{activePeriod.opis}</div>
                        )}

                        {activePeriod && <PricesTable period={activePeriod} />}
                    </>
                )}

                <div className="prices-description">
                    <p className="prices-description-bold">WAŻNE Płatność tylko gotówką (nie przyjmujemy płatności
                        kartami)</p>
                    <p className="prices-description-regular">Nr konta: PL56 1050 1230 1000 0090 8402 4828</p>
                    <p className="prices-description-regular">TRANSKAR LOGISTYKA SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ</p>
                    <p className="prices-description-regular">Ul. Myśliwska 1, 41-303 Dąbrowa Górnicza</p>
                    <p className="prices-description-regular">W tytule proszę podać numer i nazwisko osoby na którą jest rezerwacja.</p>
                </div>
            </div>
        </div>
    );
}

export default Prices;
